import {MonoTypeOperatorFunction} from 'rxjs';
import {tap} from 'rxjs/operators';
import {EnvironmentConfiguration} from '../service/core/environment-configuration.service';

export function logErrorIfInDev<T>(): MonoTypeOperatorFunction<T> {
  return tap((error: T) => {
    if (EnvironmentConfiguration.enableProdMode()) return;
    // eslint-disable-next-line no-console
    console.error(error);
  });
}
